export enum SettingsTab {
  PROFILE = 'profile',
  ACCESS = 'access',
  INTEGRATIONS = 'integrations',
  USAGE = 'usage'
}
